module.exports = __webpack_public_path__ + "static/media/girl-6.0a309e3e.svg";